import { parseBlogMarkdown } from "./parse";
import type { BlogPost } from "./types";

const rawModules = import.meta.glob("../../content/blog/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

function loadAll(): BlogPost[] {
  const posts: BlogPost[] = [];
  for (const [path, raw] of Object.entries(rawModules)) {
    const file = path.split("/").pop() ?? "post.md";
    try {
      posts.push(parseBlogMarkdown(raw, file));
    } catch (e) {
      console.warn("Failed to parse blog post", path, e);
    }
  }
  return posts.sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
}

export const blogPosts: BlogPost[] = loadAll();

export function getPostBySlug(slug: string): BlogPost | undefined {
  return blogPosts.find((p) => p.slug === slug);
}

export function latestPosts(n = 3): BlogPost[] {
  return blogPosts.slice(0, n);
}
